import * as z from 'zod'
import {buildPageSchemaForTemplate} from '@github-ui/swp-core/schemas/contentful/contentTypes/containerPage'
import {TemplateFlexSuiteOverviewSchema} from './templateFlexSuiteOverview'
import {TemplateFlexSuiteDetailsSchema} from './templateFlexSuiteDetails'

export const FlexSuiteOverviewPageSchema = buildPageSchemaForTemplate(TemplateFlexSuiteOverviewSchema)
export type FlexSuiteOverviewPage = z.infer<typeof FlexSuiteOverviewPageSchema>

export const FlexSuiteDetailsPageSchema = buildPageSchemaForTemplate(TemplateFlexSuiteDetailsSchema)
export type FlexSuiteDetailsPage = z.infer<typeof FlexSuiteDetailsPageSchema>
